module.exports = __webpack_public_path__ + "img/order_paying.c3ccedfd.svg";